// PERSISTÊNCIA DO PLANO DE CORTE (coleção planos_corte)
// Ciclo: rascunho → aprovado (reserva chapas) → cortado (baixa + retalhos).
// ---------------------------------------------------
function nestingTravarCampos(travar){
  ['nest-material','nest-scope','nest-esp','nest-slabW','nest-slabH','nest-kerf','nest-refilo','nest-veio','nest-fonte'].forEach(id=>{
    const el=document.getElementById(id);if(el)el.disabled=!!travar;
  });
  const wrap=document.getElementById('nest-chapas-wrap');
  if(wrap&&travar)wrap.style.display='none';
}

function nestingPopularPlanosSalvos(){
  const sel=document.getElementById('nest-planos');
  if(!sel) return;
  let planos=DB.get('planos_corte');
  if(_nestingScope==='medicao'&&_nestingMedicaoId) planos=planos.filter(p=>p.medicaoId===_nestingMedicaoId);
  planos.sort((a,b)=>(b.criadoEm||'').localeCompare(a.criadoEm||''));
  sel.innerHTML='<option value="">— Novo cálculo (não salvo) —</option>'+planos.map(p=>`<option value="${escapeHtml(p.id)}">#${p.numero||'?'} · ${escapeHtml(p.material)} ${p.espessura}cm · ${(NEST_PLANO_LABEL[p.status]||p.status).split(' ')[0]} · ${p.criadoEm?new Date(p.criadoEm).toLocaleDateString('pt-BR'):''}</option>`).join('');
  sel.value=_nestingPlanoAberto?.id||'';
}

function nestingSelecionarPlano(id){
  if(!id){_nestingPlanoAberto=null;nestingTravarCampos(false);renderNestingPlano();return;}
  const plano=DB.get('planos_corte').find(p=>p.id===id);
  if(!plano){toast('Plano não encontrado','error');return;}
  _nestingPlanoAberto=plano;
  document.getElementById('nest-material').value=plano.material;
  document.getElementById('nest-esp').innerHTML=`<option value="${plano.espessura}">${plano.espessura} cm</option>`;
  document.getElementById('nest-fonte').value=plano.params.fonte||'manual';
  document.getElementById('nest-slabW').value=plano.params.slabW;
  document.getElementById('nest-slabH').value=plano.params.slabH;
  document.getElementById('nest-kerf').value=plano.params.kerf*10;
  document.getElementById('nest-refilo').value=plano.params.refilo;
  document.getElementById('nest-veio').value=plano.params.veioTravado?'travar':'livre';
  nestingTravarCampos(true);
  nestingRenderPlanoSalvo();
}

function nestingRenderPlanoSalvo(){
  const plano=_nestingPlanoAberto;if(!plano)return;
  const out=document.getElementById('nest-output');
  const idxMap=new Map();let i=0;
  plano.chapas.forEach(ch=>ch.pecas.forEach(p=>{if(!idxMap.has(p.id))idxMap.set(p.id,++i);}));
  let desatualizado=false;
  try{
    const atuais=extrairPecasGlobal(plano.material).filter(p=>p.esp===plano.espessura);
    desatualizado=nestingAssinatura(atuais)!==plano.assinatura;
  }catch(e){console.error(e);}
  plano._desatualizado=desatualizado;
  let html='';
  if(desatualizado&&plano.status!=='cortado') html+=`<div style="background:#fee2e2;border:1.5px solid #dc2626;border-radius:8px;padding:12px;margin-bottom:12px;color:#b91c1c"><strong>⛔ PLANO DESATUALIZADO.</strong> As peças, medidas ou pedidos mudaram depois que este plano foi gerado. Não corte por este plano. Gere um novo cálculo e salve outra versão.</div>`;
  html+=`<div style="display:flex;gap:16px;flex-wrap:wrap;margin-bottom:14px;padding:10px 14px;background:var(--surface);border-radius:8px;font-size:13px;border:1px solid var(--border)">
    <span>📋 Plano <strong>#${plano.numero||'?'}</strong></span>
    <span>💎 <strong>${plano.chapas.length}</strong> chapa(s)${plano.params.fonte==='estoque'?' do estoque':''}</span>
    <span>🟩 <strong>${plano.aproveitamento}%</strong> aproveitamento</span>
    <span>${plano.params.veioTravado?'🧭 veio travado':'↻ rotação livre'}</span>
    <span style="color:var(--muted)">${escapeHtml(plano.material)} · ${plano.espessura} cm</span>
  </div>`;
  plano.chapas.forEach((ch,ci)=>{
    const slab={placed:ch.pecas.map(p=>({...p,px:p.x,py:p.y,pw:p.w,ph:p.h,w:p.wOrig??p.w,h:p.hOrig??p.h})),free:[]};
    const cw=ch.largura||plano.params.slabW,chh=ch.altura||plano.params.slabH;
    const info=ch.chapaRef?`Nº ${escapeHtml(String(ch.chapaRef.numero||'—'))}${ch.chapaRef.retalho?' · RETALHO':''} · estoque`:'';
    html+=nestingSvgRender(slab,cw,chh,plano.params.kerf,plano.params.refilo,ci,idxMap,plano.params.veioTravado,info);
    if(ch.sobras?.length) html=html.replace(/<\/section>$/,`<div style="border:1px solid #e2e8f0;border-top:none;border-radius:0 0 8px 8px;padding:6px 10px;font-size:11px;background:#f0fdf4;color:#166534"><strong>Sobras aproveitáveis (até):</strong> ${ch.sobras.map(r=>`${r.w}×${r.h} cm`).join(' · ')}</div></section>`);
  });
  if(plano.naoAlocadas?.length){
    html+=`<div style="background:#fee2e2;padding:12px;border-radius:8px;border:1px solid #fca5a5;margin-top:8px"><strong style="color:#dc2626">⛔ Peças não alocadas neste plano:</strong><ul style="margin:8px 0 0;padding-left:18px;font-size:12px">${plano.naoAlocadas.map(p=>`<li>${escapeHtml(p.nome)} — ${p.w}×${p.h} cm</li>`).join('')}</ul></div>`;
  }
  _nestingCalcAtual={material:plano.material,espessura:plano.espessura,fonte:plano.params.fonte||'manual',kerf:plano.params.kerf,refilo:plano.params.refilo,veioTravado:plano.params.veioTravado};
  html+=nestingChecklistHtml();
  out.innerHTML=html;
  nestingRenderBanner(plano);
  nestingRenderAcoes();
}

function nestingRenderBanner(plano){
  const el=document.getElementById('nest-banner');if(!el)return;
  if(!plano){el.style.display='none';el.innerHTML='';return;}
  const cores={rascunho:['#fffbeb','#b45309'],aprovado:['#ecfdf5','#047857'],cortado:['#eef2ff','#3730a3']};
  const [bg,fg]=cores[plano.status]||cores.rascunho;
  const hist=[];
  if(plano.criadoEm) hist.push(`criado por ${escapeHtml(plano.criadoPor||'?')} em ${new Date(plano.criadoEm).toLocaleString('pt-BR')}`);
  if(plano.aprovadoEm) hist.push(`aprovado por ${escapeHtml(plano.aprovadoPor||'?')} em ${new Date(plano.aprovadoEm).toLocaleString('pt-BR')}`);
  if(plano.corte?.em) hist.push(`corte registrado por ${escapeHtml(plano.corte.por||'?')} em ${new Date(plano.corte.em).toLocaleString('pt-BR')}`);
  el.style.display='';
  el.style.cssText+=`;background:${bg};color:${fg};border:1.5px solid ${fg};border-radius:8px;padding:8px 12px;margin-bottom:10px;font-size:12px`;
  el.innerHTML=`<strong>${NEST_PLANO_LABEL[plano.status]||plano.status}</strong> — plano #${plano.numero||'?'} · ${hist.join(' · ')}`;
}

function nestingRenderAcoes(){
  const el=document.getElementById('nest-actions');if(!el)return;
  const p=_nestingPlanoAberto;
  if(!p){
    el.innerHTML=`<button class="btn btn-close" style="margin-right:auto" onclick="closeModal('modal-nesting')">Fechar</button>
      <button class="btn btn-ghost" onclick="imprimirEtiquetasNesting()">🏷 Etiquetas</button>
      <button class="btn btn-ghost" onclick="imprimirNesting()">🖨️ Imprimir</button>
      <button class="btn btn-primary" onclick="salvarPlanoCorte()">💾 Salvar plano</button>`;
    return;
  }
  let btns=`<button class="btn btn-ghost" onclick="nestingSelecionarPlano('')">↩ Novo cálculo</button>
    <button class="btn btn-ghost" onclick="imprimirEtiquetasNesting()">🏷 Etiquetas</button>
    <button class="btn btn-ghost" onclick="imprimirNesting()">🖨️ Imprimir</button>`;
  if(p.status==='rascunho') btns+=`<button class="btn btn-danger" onclick="excluirPlanoCorte()"><i class="ti ti-trash"></i> Excluir</button>
    <button class="btn btn-primary" onclick="aprovarPlanoCorte()">✔ Aprovar para corte</button>`;
  if(p.status==='aprovado') btns+=`<button class="btn btn-ghost" onclick="voltarRascunhoPlanoCorte()">↩ Voltar a rascunho</button>
    <button class="btn btn-primary" onclick="registrarCortePlanoCorte()">✂ Registrar corte executado</button>`;
  if(p.status==='cortado') btns+=`<button class="btn btn-primary" onclick="imprimirRomaneioNesting()">📦 Romaneio de expedição</button>`;
  el.innerHTML=btns;
}

async function salvarPlanoCorte(){
  const c=_nestingCalcAtual;
  if(!c||!c.slabs){toast('Gere um plano válido antes de salvar.','error');return;}
  const lista=DB.get('planos_corte');
  const numero=lista.reduce((mx,p)=>Math.max(mx,p.numero||0),0)+1;
  const item={
    id:nestUid('plc'),
    numero,
    material:c.material,
    espessura:c.espessura,
    params:{fonte:c.fonte||'manual',slabW:c.slabW,slabH:c.slabH,kerf:c.kerf,refilo:c.refilo,veioTravado:c.veioTravado},
    escopo:c.escopo,
    medicaoId:c.medicaoId||null,
    pedidoIds:c.pedidoIds||[],
    chapas:c.slabs.map((s,i)=>{
      const ch=(c.chapasReais||[])[i]||null;
      return {
        chapaRef:ch?{estoqueId:ch.estoqueId,chapaId:ch.chapaId,numero:ch.numero,retalho:!!ch.retalho,custo:nestNum(ch.custo)||0}:null,
        largura:ch?ch.largura:c.slabW,
        altura:ch?ch.altura:c.slabH,
        pecas:s.placed.map(p=>({id:p.id,uid:p.uid||null,tipo:p.tipo,nome:p.nome,pedidoId:p.pedidoId||null,pedidoNum:p.pedidoNum||'',cliente:p.cliente||'',ambiente:p.ambiente||'',x:Math.round(p.px*10)/10,y:Math.round(p.py*10)/10,w:Math.round(p.pw*10)/10,h:Math.round(p.ph*10)/10,wOrig:p.w,hOrig:p.h,rotated:!!p.rotated,foraEsquadro:!!p.foraEsquadro,engaste:p.engaste||0,semDesenho:!!p.semDesenho,naoLiberada:!!p.naoLiberada,revisao:p.revisao||0})),
        sobras:nestingSobras(s)
      };
    }),
    naoAlocadas:(c.overflows||[]).map(p=>({nome:p.nome,pedidoNum:p.pedidoNum||'',cliente:p.cliente||'',w:p.w,h:p.h})),
    aproveitamento:c.aproveitamento,
    totalPecasM2:c.totalM2,
    assinatura:c.assinatura,
    origemPendente:!!c.origemPendente,
    pendencias:{semDesenho:c.semDesenho||0,foraEsquadro:c.foraEsq||0,naoLiberada:c.naoLiberada||0},
    status:'rascunho',
    criadoEm:new Date().toISOString(),
    criadoPor:nestUsuarioAtual()
  };
  lista.push(item);
  await DB.set('planos_corte',lista);
  await auditar('criar','planos_corte',`Plano de corte #${numero} — ${item.material} ${item.espessura}cm · ${item.chapas.length} chapa(s) · ${item.aproveitamento}%`,null,item);
  _nestingPlanoAberto=item;
  nestingPopularPlanosSalvos();
  nestingTravarCampos(true);
  nestingRenderPlanoSalvo();
  toast(`Plano de corte #${numero} salvo como rascunho ✅`);
}

// Recalcula os totais de um item de estoque após mudar status das chapas.
function estoqueRecalcularTotais(item){
  const chapas=item.chapas||[];
  const total=chapas.filter(c=>c.status!=='cortado').reduce((s,c)=>s+(nestNum(c.m2)||0),0);
  const reservado=chapas.filter(c=>c.status==='reservado').reduce((s,c)=>s+(nestNum(c.m2)||0),0);
  item.totalM2=Math.round(total*100)/100;
  item.reservadoM2=Math.round(reservado*100)/100;
  item.disponivelM2=Math.round(Math.max(0,total-reservado)*100)/100;
  item.updatedAt=new Date().toISOString();
}

// Reserva (ou libera) no estoque as chapas físicas de um plano.
async function nestingReservarChapas(plano,reservar){
  const refs=(plano.chapas||[]).map(ch=>ch.chapaRef).filter(Boolean);
  if(!refs.length) return {ok:true,nada:true};
  // v350: reserva TRANSACIONAL por item de estoque (fdb.runTransaction) — a guarda
  // anterior lia o cache local e permitia dois usuários reservarem a MESMA chapa.
  // A transação lê o estado vigente no servidor e só confirma se a chapa continua
  // disponível; a segunda tentativa concorrente falha com mensagem clara.
  const porEstoque=new Map();
  refs.forEach(ref=>{if(!porEstoque.has(ref.estoqueId))porEstoque.set(ref.estoqueId,[]);porEstoque.get(ref.estoqueId).push(ref)});
  const falhas=[];
  for(const [estoqueId,grupo] of porEstoque){
    try{
      await fdb.runTransaction(async tx=>{
        const ref=appCollection('estoque').doc(estoqueId);
        const snap=await tx.get(ref);
        if(!snap.exists)throw new Error(`Item de estoque não existe mais (${estoqueId}).`);
        const cur=snap.data();
        grupo.forEach(r=>{
          const cRow=(cur.chapas||[]).find(c=>c.id===r.chapaId);
          if(!cRow)throw new Error(`Chapa ${r.numero||r.chapaId} não existe mais no estoque.`);
          if(reservar&&cRow.status!=='disponivel')throw new Error(`Chapa ${cRow.numero||''} não está mais disponível (${cRow.status}).`);
          if(!reservar&&cRow.status!=='reservado')return;
          cRow.status=reservar?'reservado':'disponivel';
          cRow.reservaPlanoId=reservar?plano.id:null;
        });
        if(typeof cur.totalDisponivel!=='undefined')cur.totalDisponivel=(cur.chapas||[]).filter(c=>c.status==='disponivel').length;
        tx.set(ref,{...cur,_version:(Number(cur._version)||0)+1,updatedAt:firebase.firestore.FieldValue.serverTimestamp()},{merge:true});
      });
      const estoque=DB.get('estoque');
      const item=estoque.find(e=>e.id===estoqueId);
      if(item){
        grupo.forEach(r=>{const cRow=item.chapas?.find(c=>c.id===r.chapaId);if(cRow){cRow.status=reservar?'reservado':'disponivel';cRow.reservaPlanoId=reservar?plano.id:null}});
        item._version=(Number(item._version)||0)+1;
        estoqueRecalcularTotais(item);
        CACHE.estoque=estoque;
      }
    }catch(e){falhas.push(e?.message||String(e))}
  }
  if(falhas.length) return {ok:false,falhas};
  return {ok:true};
}

// Baixa das chapas cortadas + sobras viram retalhos disponíveis.
async function nestingBaixarChapas(plano){
  const estoque=DB.get('estoque');
  const tocados=new Set();let retalhos=0;let custoTotal=0;
  (plano.chapas||[]).forEach((ch,i)=>{
    const ref=ch.chapaRef;if(!ref)return;
    const item=estoque.find(e=>e.id===ref.estoqueId);
    const cRow=item?.chapas?.find(c=>c.id===ref.chapaId);
    if(!item||!cRow)return;
    cRow.status='cortado';cRow.reservaPlanoId=null;cRow.cortePlanoId=plano.id;
    custoTotal+=nestNum(cRow.custo)||nestNum(ref.custo)||0;
    tocados.add(item.id);
    // sobras não sobrepostas (as antigas sem posição: só a maior)
    const kept=[];
    (ch.sobras||[]).forEach(r=>{
      if(r.x==null){if(!kept.length)kept.push(r);return;}
      if(!kept.some(k=>k.x!=null&&!(r.x>=k.x+k.w||k.x>=r.x+r.w||r.y>=k.y+k.h||k.y>=r.y+r.h)))kept.push(r);
    });
    kept.forEach((r,ri)=>{
      if(!(r.w>=NEST_SOBRA_MIN&&r.h>=NEST_SOBRA_MIN))return;
      item.chapas.push({
        id:nestUid('chapa'),
        numero:`RET ${plano.numero}.${i+1}${kept.length>1?'-'+(ri+1):''}`,
        largura:r.w,altura:r.h,
        m2:Math.round(r.w*r.h/100)/100,
        status:'disponivel',retalho:true,origemPlanoId:plano.id,foto:''
      });
      retalhos++;
    });
  });
  estoque.filter(e=>tocados.has(e.id)).forEach(estoqueRecalcularTotais);
  if(tocados.size) await DB.set('estoque',estoque);
  return {retalhos,custoTotal:Math.round(custoTotal*100)/100};
}
// Custeio automático: chapas baixadas viram apontamento de MATERIAL
// no pedido (fecha o Estimado × Realizado sem lançamento manual).
async function nestingLancarCustoMaterial(plano,custoTotal){
  if(!(custoTotal>0))return false;
  if((plano.pedidoIds||[]).length!==1)return false; // plano multi-pedido: lançar manualmente
  const lista=[...DB.get('custos_producao')];
  lista.unshift({id:uid(),pedidoId:plano.pedidoIds[0],data:today(),dataFim:'',etapa:'material',
    desc:`Chapas consumidas no plano de corte #${plano.numero}`,responsavel:'',horas:0,capacidadeHoras:0,excessoHoras:0,inconsistenciaHoras:false,valorHora:0,
    valor:custoTotal,retrabalho:false,motivoRetrabalho:'',origemPlanoId:plano.id,createdAt:new Date().toISOString()});
  await DB.set('custos_producao',lista);
  await auditar('criar','custos_producao',`Custo real de material ${fmt(custoTotal)} lançado do plano #${plano.numero}`,null,{planoId:plano.id,valor:custoTotal});
  return true;
}

async function aprovarPlanoCorte(){
  const p=_nestingPlanoAberto;if(!p)return;
  if(p.status!=='rascunho'){toast('Somente rascunhos podem ser aprovados.','error');return;}
  if(!exigirAprovador('aprovar planos de corte'))return;
  if(p._desatualizado){toast('Plano desatualizado: as peças mudaram. Gere e salve um novo plano.','error');return;}
  if(p.origemPendente){toast('Aprove primeiro a medição (Medições → ✔ Aprovar) para liberar este plano.','error');return;}
  if(p.medicaoId){
    const medConf=(CACHE.medicoes||[]).find(m=>m.id===p.medicaoId);
    const minimo=CACHE.config?.preConfMinimo==null?70:geoNum(CACHE.config.preConfMinimo);
    if(medConf){const pc2=preConferenciaMedicao(medConf);
      if(pc2.pct<minimo){toast(`Pré-conferência do projeto em ${pc2.pct}% — mínimo para liberar corte é ${minimo}% (Configurações). Complete os desenhos das peças.`,'error');return;}}
  }
  const pend=[];
  if(p.pendencias?.semDesenho) pend.push(`${p.pendencias.semDesenho} peça(s) sem desenho técnico`);
  if(p.pendencias?.naoLiberada){toast(`Plano bloqueado: ${p.pendencias.naoLiberada} peça(s) ainda não possui(em) liberação técnica individual.`,'error');return;}
  if(p.naoAlocadas?.length) pend.push(`${p.naoAlocadas.length} peça(s) não alocada(s)`);
  const temChapas=(p.chapas||[]).some(ch=>ch.chapaRef);
  const msg=(pend.length?`ATENÇÃO — pendências:\n• ${pend.join('\n• ')}\n\n`:'')+`Aprovar este plano para corte?${temChapas?'\nAs chapas físicas do estoque serão RESERVADAS para este plano.':''} Após a aprovação o layout fica congelado.`;
  if(!await uiConfirm({tone:pend.length?'warning':'default',eyebrow:'Plano de corte',title:'Aprovar layout para corte?',message:msg,impact:'Após a aprovação, o layout fica congelado e as chapas físicas serão reservadas quando vinculadas.',confirmLabel:'Aprovar plano'})) return;
  const res=await nestingReservarChapas(p,true);
  if(!res.ok){toast('Não foi possível reservar as chapas:\n'+res.falhas.join('\n'),'error');return;}
  await nestingAtualizarPlano(p.id,pl=>{pl.status='aprovado';pl.aprovadoEm=new Date().toISOString();pl.aprovadoPor=nestUsuarioAtual();});
  toast(temChapas?'Plano aprovado ✔ — chapas reservadas no estoque.':'Plano aprovado para corte ✔');
}

async function voltarRascunhoPlanoCorte(){
  const p=_nestingPlanoAberto;if(!p)return;
  if(p.status!=='aprovado'){toast('Somente planos aprovados voltam a rascunho.','error');return;}
  if(!exigirAprovador('reabrir planos de corte'))return;
  if(!await uiConfirm({tone:'warning',eyebrow:'Plano de corte',title:`Voltar o plano #${p.numero} para rascunho?`,impact:'As reservas de chapa serão liberadas e o layout poderá ser editado novamente.',confirmLabel:'Voltar para rascunho'})) return;
  await nestingReservarChapas(p,false);
  await nestingAtualizarPlano(p.id,pl=>{pl.status='rascunho';pl.aprovadoEm=null;pl.aprovadoPor=null;});
  toast('Plano reaberto como rascunho, reservas liberadas.');
}

async function registrarCortePlanoCorte(){
  const p=_nestingPlanoAberto;if(!p)return;
  if(p.status!=='aprovado'){toast('Registre o corte apenas de planos aprovados.','error');return;}
  if(!exigirAprovador('registrar corte'))return;
  const temChapas=(p.chapas||[]).some(ch=>ch.chapaRef);
  if(!await uiConfirm({tone:'danger',eyebrow:'Execução do corte',title:`Registrar corte do plano #${p.numero}?`,message:`Confirme que ${p.chapas.reduce((s,c)=>s+c.pecas.length,0)} peça(s) foram cortadas conforme o layout.`,impact:temChapas?'As chapas serão baixadas do estoque e as sobras entrarão como retalhos disponíveis.':'As sobras precisam ser etiquetadas e lançadas manualmente como retalho.',confirmLabel:'Registrar corte executado'})) return;
  let baixa={retalhos:0,custoTotal:0};
  if(temChapas) baixa=await nestingBaixarChapas(p);
  const lancou=await nestingLancarCustoMaterial(p,baixa.custoTotal);
  await nestingAtualizarPlano(p.id,pl=>{pl.status='cortado';pl.corte={em:new Date().toISOString(),por:nestUsuarioAtual(),retalhosGerados:baixa.retalhos,custoChapas:baixa.custoTotal};});
  if(typeof renderEstoque==='function'&&document.getElementById('page-estoque')?.classList.contains('active'))renderEstoque();
  toast(temChapas?`Corte registrado ✂ — ${baixa.retalhos} retalho(s) no estoque${baixa.custoTotal>0?`; custo real ${fmt(baixa.custoTotal)}${lancou?' lançado em Custos de Produção':' (plano com vários pedidos, lance o material manualmente)'}`:''}.`:'Corte registrado ✂ — lance as sobras no estoque como retalhos.');
}

async function excluirPlanoCorte(){
  const p=_nestingPlanoAberto;if(!p)return;
  if(p.status!=='rascunho'){toast('Planos aprovados ou cortados não podem ser excluídos (rastreabilidade).','error');return;}
  if(!await uiConfirm({tone:'danger',eyebrow:'Plano de corte',title:`Excluir o rascunho #${p.numero}?`,impact:'Somente o rascunho será removido; planos aprovados ou cortados permanecem protegidos.',confirmLabel:'Excluir rascunho'})) return;
  const antes=JSON.parse(JSON.stringify(p));
  await DB.remove('planos_corte',p.id);
  await auditar('excluir','planos_corte',`Excluiu rascunho do plano de corte #${p.numero}`,antes,null);
  _nestingPlanoAberto=null;
  nestingTravarCampos(false);
  nestingPopularPlanosSalvos();
  renderNestingPlano();
}

async function nestingAtualizarPlano(id,mutador){
  const lista=DB.get('planos_corte');
  const idx=lista.findIndex(x=>x.id===id);
  if(idx<0){toast('Plano não encontrado.','error');return;}
  const antes=JSON.parse(JSON.stringify(lista[idx]));
  mutador(lista[idx]);
  lista[idx].updatedAt=new Date().toISOString();
  await DB.set('planos_corte',lista);
  await auditar('editar','planos_corte',`Plano de corte #${lista[idx].numero} → ${lista[idx].status}`,antes,lista[idx]);
  _nestingPlanoAberto=lista[idx];
  nestingPopularPlanosSalvos();
  nestingRenderPlanoSalvo();
}

function imprimirRomaneioNesting(){
  const p=_nestingPlanoAberto;
  if(!p){toast('Abra um plano salvo para gerar o romaneio.','error');return;}
  const pecas=p.chapas.flatMap((ch,i)=>ch.pecas.map(pc=>({...pc,chapa:ch.chapaRef?String(ch.chapaRef.numero):`Chapa ${i+1}`})));
  if(!pecas.length){toast('O plano não tem peças.','error');return;}
  const cfg=CACHE.config||{};
  const linhas=pecas.map((pc,i)=>`<tr>
    <td style="text-align:center;font-size:16px">☐</td><td style="text-align:center">${i+1}</td>
    <td style="font-family:monospace;font-size:10px">${escapeHtml(pc.uid||'—')}</td>
    <td><strong>${escapeHtml(pc.nome||'—')}</strong></td>
    <td style="font-family:monospace">${(pc.w||0).toFixed(1)}×${(pc.h||0).toFixed(1)}</td>
    <td>${escapeHtml(pc.cliente||'—')}</td><td>P.${escapeHtml(String(pc.pedidoNum||'—'))}</td>
    <td>${escapeHtml(pc.ambiente||'—')}</td><td>${escapeHtml(pc.chapa)}</td>
    <td style="width:110px;border-bottom:1px solid #cbd5e1"></td>
  </tr>`).join('');
  abrirDocumentoImpressao(`Romaneio de expedição — Plano #${p.numero}`,`
    <div class="header"><div class="brand">${logoEmpresaHtml(cfg)}<div><h1>${escapeHtml(cfg.nome||'Marmoraria')}</h1><div class="muted">ROMANEIO DE EXPEDIÇÃO E CONFERÊNCIA</div></div></div>
    <div style="text-align:right"><strong>Plano de corte #${p.numero}</strong><br>${escapeHtml(p.material)} · ${p.espessura} cm<br>${NEST_PLANO_LABEL[p.status]||p.status}</div></div>
    <div class="box" style="font-size:12px">Conferir <strong>peça por peça</strong> no carregamento: medidas, acabamento, furos/cubas e ausência de trincas. Anotar avarias na coluna de observações. Peça sem etiqueta não embarca.</div>
    <table style="width:100%;border-collapse:collapse;font-size:11.5px" border="1" cellpadding="5">
      <thead><tr style="background:#f1f5f9"><th>✓</th><th>#</th><th>ID</th><th>Peça</th><th>Medidas (cm)</th><th>Cliente</th><th>Pedido</th><th>Ambiente</th><th>Chapa</th><th>Observação / avaria</th></tr></thead>
      <tbody>${linhas}</tbody></table>
    <div style="display:flex;gap:34px;margin-top:44px"><div style="flex:1;border-top:1px solid #334155;text-align:center;padding-top:4px;font-size:11px">Conferente (expedição)</div><div style="flex:1;border-top:1px solid #334155;text-align:center;padding-top:4px;font-size:11px">Motorista / instalador</div><div style="flex:1;border-top:1px solid #334155;text-align:center;padding-top:4px;font-size:11px">Data / hora</div></div>`);
}
function imprimirEtiquetasNesting(){
  const p=_nestingPlanoAberto,c=_nestingCalcAtual;
  let grupos=[];
  if(p){grupos=p.chapas.map((ch,i)=>({chapa:ch.chapaRef?`${ch.chapaRef.numero}`:`CHAPA ${i+1}`,plano:`PLANO #${p.numero}`,pecas:ch.pecas}));}
  else if(c&&c.slabs){grupos=c.slabs.map((s2,i)=>({chapa:(c.chapasReais||[])[i]?String(c.chapasReais[i].numero):`CHAPA ${i+1}`,plano:'CÁLCULO NÃO SALVO',pecas:s2.placed.map(x=>({...x,x:x.px,y:x.py,w:x.pw,h:x.ph}))}));}
  if(!grupos.length||!grupos.some(g=>g.pecas.length)){toast('Gere ou abra um plano antes de imprimir etiquetas.','error');return;}
  const material=(p?p.material:c.material)||'—',esp=(p?p.espessura:c.espessura)||'—';
  const veio=(p?p.params.veioTravado:c.veioTravado);
  let n=0;
  const labels=grupos.flatMap(g=>g.pecas.map(pc=>{n++;return`<div class="etq">
    <div class="etq-top"><strong>#${n}</strong><span>${escapeHtml(g.plano)} · ${escapeHtml(g.chapa)}</span></div>
    <div class="etq-nome">${escapeHtml(pc.nome||'Peça')}</div>
    <div class="etq-dim">${(pc.w||0).toFixed(1)} × ${(pc.h||0).toFixed(1)} cm${pc.rotated?' ↻':''}</div>
    <div class="etq-linha">${escapeHtml(pc.cliente||'—')} · P.${escapeHtml(String(pc.pedidoNum||'—'))} · ${escapeHtml(pc.ambiente||'—')}</div>
    <div class="etq-linha">${escapeHtml(material)} · ${esp} cm${veio?' · VEIO ⟶':''}</div>
    <div class="etq-uid">${escapeHtml(pc.uid||'')}</div>
  </div>`}));
  abrirDocumentoImpressao(`Etiquetas — Plano de Corte`,`<style>
    .etq-grid{display:grid;grid-template-columns:1fr 1fr;gap:0}
    .etq{border:1.5px dashed #64748b;padding:10px 12px;break-inside:avoid;font-family:system-ui,Arial,sans-serif}
    .etq-top{display:flex;justify-content:space-between;font-size:10px;color:#475569;margin-bottom:4px}
    .etq-top strong{font-size:15px;color:#0f172a}
    .etq-nome{font-size:15px;font-weight:800;color:#0f172a}
    .etq-dim{font-size:18px;font-weight:800;letter-spacing:.02em;margin:2px 0}
    .etq-linha{font-size:10.5px;color:#334155}
    .etq-uid{font-size:10px;font-family:monospace;color:#64748b;margin-top:4px;letter-spacing:.08em}
  </style><div class="etq-grid">${labels.join('')}</div>`);
}
function imprimirNesting(){
  const c=_nestingCalcAtual;
  const p=_nestingPlanoAberto;
  const material=c?.material||document.getElementById('nest-material')?.value||'—';
  const status=p?` · ${NEST_PLANO_LABEL[p.status]||p.status}${p._desatualizado?' · ⛔ DESATUALIZADO':''}`:' · CÁLCULO NÃO SALVO';
  const cab=`<div style="border:1.5px solid #334155;border-radius:8px;padding:10px 14px;margin-bottom:12px;font-size:13px"><strong>PLANO DE CORTE${p?` #${p.numero}`:''}</strong> — ${escapeHtml(material)} · ${c?.espessura||'—'} cm${status}<br><small>${p?.criadoEm?`Criado por ${escapeHtml(p.criadoPor||'?')} em ${new Date(p.criadoEm).toLocaleString('pt-BR')}. `:''}${p?.aprovadoEm?`Aprovado por ${escapeHtml(p.aprovadoPor||'?')} em ${new Date(p.aprovadoEm).toLocaleString('pt-BR')}. `:''}${p?.corte?.em?`Corte registrado em ${new Date(p.corte.em).toLocaleString('pt-BR')}.`:''}</small></div>`;
  abrirDocumentoImpressao(`Plano de Corte — ${material}`,cab+(document.getElementById('nest-output')?.innerHTML||''));
}

